import apiClient from './client';

// Common query params for all report endpoints: from, to, owner_id, region
// GET /api/reports/conversion-metrics
export async function fetchConversionMetrics(params = {}) {
  const response = await apiClient.get('/reports/conversion-metrics', { params });
  return response.data;
}

// GET /api/reports/leads-by-source
export async function fetchLeadsBySource(params = {}) {
  const response = await apiClient.get('/reports/leads-by-source', { params });
  return response.data;
}

// GET /api/reports/leads-by-stage
export async function fetchLeadsByStage(params = {}) {
  const response = await apiClient.get('/reports/leads-by-stage', { params });
  return response.data;
}

// GET /api/reports/leads-by-region
export async function fetchLeadsByRegion(params = {}) {
  const response = await apiClient.get('/reports/leads-by-region', { params });
  return response.data;
}

// GET /api/reports/agent-performance
// Extra param: agent_id
export async function fetchAgentPerformance(params = {}) {
  const response = await apiClient.get('/reports/agent-performance', { params });
  return response.data;
}
